import API from "../config";

export function getAccessToken() {
  return localStorage.getItem("access_token");
}

export function clearSession() {
  localStorage.removeItem("access_token");
  localStorage.removeItem("loggedIn");
  localStorage.removeItem("admin_id");
  localStorage.removeItem("username");
  localStorage.removeItem("role");
  localStorage.removeItem("company_id");
}

function redirectToLogin() {
  clearSession();

  if (window.location.pathname !== "/login") {
    window.location.assign("/login");
  }
}

export async function apiFetch(path, options = {}) {
  const token = getAccessToken();

  const headers = new Headers(options.headers || {});

  if (
    options.body &&
    !(options.body instanceof FormData) &&
    !headers.has("Content-Type")
  ) {
    headers.set("Content-Type", "application/json");
  }

  if (token && !headers.has("Authorization")) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  const response = await fetch(`${API}${path}`, {
    ...options,
    headers,
  });

  if (response.status === 401) {
    redirectToLogin();
    throw new Error("Your session has expired. Please sign in again.");
  }

  if (response.status === 403) {
    throw new Error(
      "You do not have permission to perform this action."
    );
  }

  return response;
}

export async function apiJson(path, options = {}) {
  const response = await apiFetch(path, options);

  let data = null;

  try {
    data = await response.json();
  } catch {
    data = null;
  }

  if (!response.ok) {
    throw new Error(
      data?.detail ||
        data?.message ||
        `Request failed with status ${response.status}.`
    );
  }

  return data;
}

export async function downloadAuthenticatedFile(
  path,
  fallbackFileName
) {
  const response = await apiFetch(path);

  if (!response.ok) {
    let message = `Download failed with status ${response.status}.`;

    try {
      const errorData = await response.json();
      message =
        errorData?.detail ||
        errorData?.message ||
        message;
    } catch {
      // The response was not JSON.
    }

    throw new Error(message);
  }

  const blob = await response.blob();

  const disposition =
    response.headers.get("content-disposition") || "";

  const fileNameMatch = disposition.match(
    /filename\*?=(?:UTF-8'')?["']?([^;"']+)/i
  );

  const fileName = fileNameMatch
    ? decodeURIComponent(fileNameMatch[1].replace(/["']/g, ""))
    : fallbackFileName;

  const objectUrl = window.URL.createObjectURL(blob);
  const anchor = document.createElement("a");

  anchor.href = objectUrl;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();

  window.URL.revokeObjectURL(objectUrl);
}
